import View from '../../View';

/**
 * CookieWall
 */
class CookieWall extends View {
    /**
     * Construct CookieWall
     * @param node
     */
    constructor (node) {
        super(node);

        this.closeButton = this.node.querySelector('.js-cookie-wall-close-button');
        this.closeButton.addEventListener('click', this.closeButtonClickHandler);
    };

    /**
     * Handle closing the cookieWall
     * @param e
     */
    closeButtonClickHandler = (e) => {
        e.preventDefault();

        //Set a cookie that lasts for a year
        document.cookie = "acceptCookies=true;max-age=31536000";

        this.node.classList.add('mod-hidden');
    }
}

export default CookieWall;



// WEBPACK FOOTER //
// frontend/js/components/blocks/CookieWall.js